import { render, staticRenderFns } from "./ParticularForm.vue?vue&type=template&id=ff52a7ba&scoped=true"
import script from "./ParticularForm.vue?vue&type=script&lang=ts"
export * from "./ParticularForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff52a7ba",
  null
  
)

export default component.exports